import { configuration } from "utils/Notification/configuration";

export default function notification({
    width = '300px',
    position = 'right-bottom',
    distance = '30px',
    opacity = 1,
    borderRadius = '5px',
    rtl = true,
    timeout = 3000,
    messageMaxLength = 120,
    backOverlay = false,
    backOverlayColor = 'rgba(0,0,0,0.5)',

    ID = 'NotiflixNotify',
    className = 'notiflix-notify',
    zindex = 4001,
    useGoogleFont = true,
    fontFamily = 'Iran Sans',
    fontSize = '15px',
    cssAnimation = true,
    cssAnimationDuration = 400,
    cssAnimationStyle = 'from-right',
    closeButton = false,
    useIcon = true,
    useFontAwesome = false,
    fontAwesomeIconStyle = 'basic',
    fontAwesomeIconSize = '34px',
    plainText = true} = {}) {

    const notiflix = configuration(width, position, distance, opacity, borderRadius, rtl, timeout, messageMaxLength,
        backOverlay, backOverlayColor, ID, className, zindex, useGoogleFont, fontFamily, fontSize, cssAnimation,
        cssAnimationDuration, cssAnimationStyle, closeButton, useIcon, useFontAwesome, fontAwesomeIconStyle,
        fontAwesomeIconSize, plainText)
    return {
        success: (message) => {
            return notiflix.Notify.Success(message);
        },
        failure: (message) => {
            return notiflix.Notify.Failure(message);
        },
        warning: (message) => {
            return notiflix.Notify.Warning (message);
        },
        info: (message) => {
            return notiflix.Notify.Info(message);
        },
        confirm: (title, message, confirmCaption, rejectCaption, okFunction, rejectFunction ) => {
            return notiflix.Confirm.Show(
                title,
                message,
                confirmCaption,
                rejectCaption,
                function() {
                    okFunction()
                },
                function() {
                    rejectFunction()
                }
            )
        }
    }
}